import { useTranslation } from 'react-i18next';

import { DocumentsIcon } from 'src/components/Icons/icons';
import { OrganizationModuleType } from 'src/domain/organization';
import { ModuleSettingsScreen } from '../components/ModuleSettingsScreen';

export const AppContentSettings = () => {
    const { t } = useTranslation();

    return (
        <ModuleSettingsScreen
            basePath="/app/documents"
            icon={DocumentsIcon}
            moduleType={OrganizationModuleType.appContent}
            moduleName={t('modules.appContent.navLabel')}
            memberDescription={t(
                'modules.appContent.members.settingsDescription',
            )}
        />
    );
};
